import * as React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import {
    GridRowModes,
    DataGrid,
    jaJP,
    gridClasses,
} from '@mui/x-data-grid';
import { TablePagination } from "@mui/material";
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import SearchIcon from "@mui/icons-material/Search";
import {
    CautionButton,
    NomalButton,
    GrayButton
} from '../../css/CSS.js';
import { useForm, Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import useAuthAxios from "../../../useAuthAxios";
import { useNavigate, useLocation } from 'react-router-dom';
import LoadingDialog from '../../Loading';
import RefreshIcon from '@mui/icons-material/Refresh';
import UndoIcon from '@mui/icons-material/Undo';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import UnconfirmedDeleteCheckDialog from '../UnconfirmedCheckDialog'
import InspectionBreadcrumbs from '../InspectionBreadcrumbs.js';
import { InspectionContents } from './../../css/CSS.js';
import { toHalfWidthAlpha, toHalfWidthKana, toHalfWidthNumber } from '../InspectionValidations'
import InspectionCommonDialog from '../InspectionCommonDialog'


const CustomPagination = ({ rows, paginationModel, setPaginationModel }) => {
    const page = paginationModel.page;
    const rowsPerPage = 100;
    const count = rows?.length ?? 0;

    const handleChangePage = (event, newPage) => {
        setPaginationModel((prev) => ({
            ...prev,
            page: newPage,
        }));
        const previousCondition = sessionStorage.getItem('contractSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            const newCondition = {
                ...searchConditions,
                pagination: {
                    page: newPage,
                }
            }
            sessionStorage.setItem('contractSearchCondition', JSON.stringify(newCondition));
        }
    };

    return (
        count !== 0 ?
            <TablePagination
                component="div"
                count={count}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
                rowsPerPageOptions={[]}
                labelDisplayedRows={({ from, to, count }) =>
                    `全${count}件中 ${from}件～${to}件を表示`
                }
            /> : null
    );
};

export default function PropertyAssignmentBody() {

    const [processing, setProcessing] = React.useState(false);
    const [processing_search, setProcessing_search] = React.useState(false);
    const [processing_searchReset, setProcessing_searchReset] = React.useState(false);
    const [shitenSelectList, setShitenSelectList] = React.useState([]);
    const authAxios = useAuthAxios();
    const navigate = useNavigate();
    const headers = { "Authorization": "Bearer " + localStorage.getItem("Auth") };
    const [unconfirmedDeleteCheck, setUnconfirmedDeleteCheck] = React.useState(false)
    const [unconfirmedCmd, setUnconfirmedCmd] = React.useState("")
    const [list, setList] = React.useState([]);
    const [baseList, setBaseList] = React.useState([]);
    const [assignList, setAssignList] = React.useState([]);
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [personSelectList, setPersonSelectList] = React.useState([]);
    const [propertyAssignment, setPropertyAssignment] = React.useState(false)
    const [fromAccount, setFromAccount] = React.useState(false);
    const [initialSearch, setInitialSearch] = React.useState(false);
    const [sortModel, setSortModel] = React.useState([{ field: '', sort: 'asc' }]);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 100 });

    const location = useLocation();
    var contractInfo = location.state?.contractInfo;

    //担当者一覧取得
    React.useLayoutEffect(() => {
        setProcessing(true)
        authAxios
            .get('api/inspection/InspectionVendors', { headers })
            .then(response => {
                if (response.status === 200) {
                    const listdata = JSON.parse((JSON.stringify(response.data)));
                    let selectPersonList = [];
                    selectPersonList.push({ contractNo: "", personName: "未選択" });
                    listdata.vendorInfoList.forEach((e) => {
                        if (e.delflg === 0) {
                            selectPersonList.push({ contractNo: e.contractNo, personName: e.contractName });
                        }
                    });
                    setPersonSelectList(selectPersonList);
                    setProcessing(false);
                }
            }).catch((response) => {
                alert("担当者一覧の取得に失敗しました。", response.body);
                switch (localStorage.getItem("loginType")) {
                    case "0":
                        navigate("/");
                        break
                    case "1":
                        navigate("/omsuser");
                        break
                    case "2":
                        navigate("/vender");
                        break
                    default:
                        navigate("/");
                }
                setProcessing(false)
            });
        setProcessing(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //担当支店取得
    React.useLayoutEffect(() => {
        setProcessing(true)
        authAxios
            .get('api/inspection/inspectionVendor/offices', { headers })
            .then(response => {
                if (response.status === 200) {
                    const listdata = JSON.parse((JSON.stringify(response.data)));
                    const selectList = [];
                    selectList.push({ shitenCD: "", shitenName: "未選択" })
                    listdata.shitenInfo.forEach((e) => selectList.push({ shitenCD: e.shitenCD, shitenName: e.shitenName }))
                    setShitenSelectList(selectList)
                    setProcessing(false);
                }
            }).catch((response) => {
                alert("支店情報取得に失敗しました。", response.body);
                switch (localStorage.getItem("loginType")) {
                    case "0":
                        navigate("/");
                        break
                    case "1":
                        navigate("/omsuser");
                        break
                    case "2":
                        navigate("/vender");
                        break
                    default:
                        navigate("/");
                }
                setProcessing(false)
            });
        setProcessing(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //アカウント管理画面からの遷移時、担当者と支店で初期検索を行う。
    React.useEffect(() => {
        if (!shitenSelectList || shitenSelectList.length === 0) return;
        if (contractInfo === undefined) {
            const previousCondition = sessionStorage.getItem('contractSearchCondition');
            if (previousCondition) {
                const searchConditions = JSON.parse(previousCondition);
                setValue("kojiCD", searchConditions.kojiCD);
                setValue("tantoName", searchConditions.tantoName);
                setValue("tantoShiten", searchConditions.tantoShiten);
                setValue("customerNameKana", searchConditions.customerNameKana);
                setInitialSearch(true);
            } else if (localStorage.getItem("UserShitenCD")) {
                const defaultShitenCD = localStorage.getItem("UserShitenCD");
                const target = shitenSelectList.find(item => item.shitenCD === defaultShitenCD);
                setValue("tantoShiten", target ? target.shitenCD : "");
            }
        } else {
            setValue("kojiCD", "");
            setValue("tantoName", contractInfo.contractName);
            setValue("tantoShiten", contractInfo.tantoShisyaCD);
            setValue("customerNameKana", "");
            setFromAccount(true);
        }
    }, [shitenSelectList]);

    React.useEffect(() => {
        if (!fromAccount) { return }
        propertyAssignmentSearchClick();
        setFromAccount(false);

    }, [fromAccount]);

    React.useEffect(() => {
        if (!initialSearch) { return }
        propertyAssignmentSearchClick('initialSearch');
        setInitialSearch(false);

    }, [initialSearch]);


    //検索ボタン押下
    const onSubmit = (_, e) => {
        const action = e?.nativeEvent.submitter?.value;
        switch (action) {
            case 'search':
                propertyAssignmentSearchClick();
                break;
            default:
                return null;
        }
    }
    const fieldLabels = {
        kojiCD: "工事コード",
        tantoName: "担当者名",
        customerNameKana: "邸名（半角カナ）",
    };

    const fieldToLabel = (field) => fieldLabels[field] ?? field;
    const [dialogState, setDialogState] = React.useState({ open: false });
    const onError = (errors) => {
        const firstErrorKey = Object.keys(errors)[0];
        const firstError = errors[firstErrorKey];

        const message = firstError?.message;
        const fieldLabel = fieldToLabel(firstErrorKey)
        setDialogState({
            open: true,
            title: "入力エラー",
            message: fieldLabel + "は" + message,
            confirmClick: () => { setDialogState(prev => ({ ...prev, open: false })); },
            cancelClick: () => { setDialogState(prev => ({ ...prev, open: false })); },
            confirmIcon: <></>,
            buttonType: "NomalButton",
            hideCancel: true,
        })
    };

    const propertyAssignmentSearchClick = (trigger) => {

        if (JSON.stringify(baseList) !== JSON.stringify(list)) {
            setUnconfirmedDeleteCheck(true);
            setUnconfirmedCmd("search");
        } else {
            propertyAssignmentSearch(trigger);
        }
    }
    const propertyAssignmentSearch = (trigger) => {
        if (getValues('kojiCD') || getValues('tantoName') || getValues('tantoShiten') || getValues('customerNameKana')) {
            setProcessing_search(true);
            authAxios
                .get('api/inspection/inspectionVendor/asignVender'
                    + '?kojiCD=' + getValues('kojiCD')
                    + '&tantoName=' + getValues("tantoName")
                    + '&tantoShiten=' + getValues("tantoShiten")
                    + '&customerNameKana=' + getValues("customerNameKana")
                    , { headers }
                ).then(response => {
                    if (response.status === 200) {
                        const listdata = JSON.parse((JSON.stringify(response.data.vendorAsignList)));
                        let tempListData = []
                        let incrementId = 1;
                        listdata.forEach((item) => {
                            tempListData.push({
                                id: incrementId++,
                                category: item.tenkenKbn,
                                kojiCD: item.kojiCD,
                                status: item.dispStsStr,
                                statusCD: item.stsCD,
                                yashikiName: item.yashikiName,
                                branch: item.tantoShiten,
                                person: item.tantoName,
                                personCD: item.tantoCD,
                                Scheduleddate: item.visitSchedule,
                                visitdate: item.visitAchievement,
                                workingtime: item.havingTime,
                                location: item.latitude && item.longtitude ? item.latitude + "," + item.longtitude : "なし",
                                changedStatus: false,
                            });
                        });
                        setList(tempListData)
                        setBaseList(tempListData)
                        if (trigger === 'initialSearch') {
                            const previousCondition = sessionStorage.getItem('contractSearchCondition');
                            if (previousCondition) {
                                const searchConditions = JSON.parse(previousCondition);
                                setSortModel([{
                                    field: searchConditions.sort.orderBy,
                                    sort: searchConditions.sort.order,
                                }])
                                setPaginationModel({
                                    page: searchConditions.pagination.page,
                                    pageSize: 100
                                })
                            }
                        } else {
                            const contractSearchCondition =
                            {
                                kojiCD: getValues("kojiCD"),
                                tantoName: getValues("tantoName"),
                                tantoShiten: getValues("tantoShiten"),
                                customerNameKana: getValues("customerNameKana"),
                                sort: {
                                    order: 'asc',
                                    orderBy: '',
                                },
                                pagination: {
                                    page: 0,
                                }
                            }
                            sessionStorage.setItem('contractSearchCondition', JSON.stringify(contractSearchCondition));
                            setSortModel([{
                                field: '',
                                sort: 'asc',
                            }])
                            setPaginationModel({
                                page: 0,
                                pageSize: 100
                            })
                        }

                        setProcessing_search(false)
                    } else if (response.status === 401) {
                        alert("認証に失敗しました。");
                        setProcessing_search(false)
                        switch (localStorage.getItem("loginType")) {
                            case "0":
                                navigate("/");
                                break
                            case "1":
                                navigate("/omsuser");
                                break
                            case "2":
                                navigate("/vender");
                                break
                            default:
                                navigate("/");
                        }
                    }
                })
                .catch((response) => {
                    alert("一覧情報取得に失敗しました。", response.body);
                    setProcessing_search(false)
                });
        } else {
            alert("いずれかの条件を指定してください。")

        }
    }

    //const handleEditClick = (id) => () => {
    //    //setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    //    setRowModesModel((prevModel) => ({
    //        ...prevModel,
    //        [id]: { mode: GridRowModes.Edit },
    //    }));
    //};

    //const handleSaveClick = (id) => () => {
    //    //setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    //    setRowModesModel((prevModel) => ({
    //        ...prevModel,
    //        [id]: { mode: GridRowModes.View },
    //    }));
    //};

    //const processRowUpdate = (newRow) => {
    //    if (newRow.person) {
    //        const selectedPerson = personSelectList.find(item => item.contractNo === newRow.person);
    //        if (selectedPerson) {
    //            newRow.personCD = selectedPerson.contractNo;
    //        }
    //    } else {
    //        newRow.personCD = "";
    //    }
    //    const updatedRow = { ...newRow, isNew: false };
    //    setList(list.map((row) => (row.id === newRow.id ? updatedRow : row)));
    //    setRowModesModel({ ...rowModesModel, [newRow.id]: { mode: GridRowModes.View } });
    //    return updatedRow;
    //};

    const processRowUpdate = (newRow) => {

        if (newRow.person) {
            const selectedPerson = personSelectList.find(item => item.contractNo === newRow.person);
            if (selectedPerson) {
                newRow.personCD = selectedPerson.contractNo;
            }
        } else {
            newRow.personCD = "";
        }

        const updatedRow = { ...newRow, isNew: false, changedStatus: true };
        setList(list.map((row) => (row.id === newRow.id ? updatedRow : row)));
        setRowModesModel({ ...rowModesModel, [newRow.id]: { mode: GridRowModes.View } });
        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };
    const handleCellFocusOut = (params) => {
        const { id } = params;
        if (rowModesModel[id]?.mode === GridRowModes.Edit) {
            setRowModesModel((prevModel) => ({
                ...prevModel,
                [id]: { mode: GridRowModes.View },
            }));
        }
    };

    const categoryOrder = {
        "3ヵ月点検": 0,
        "6ヵ月点検": 1,
        "12ヵ月点検": 2,
        "24ヵ月点検": 3,
        "4年点検": 4,
        "7年点検": 5,
        "10年点検": 6,
        "その他点検": 7
    };
    const tieBreaker = (row1, row2) => {
        const diffKojiCD = row1.kojiCD - row2.kojiCD;
        if (diffKojiCD !== 0) return diffKojiCD;
        const diffCategory = categoryOrder[row1.category] - categoryOrder[row2.category];
        if (diffCategory !== 0) return diffCategory;
        return row1.id - row2.id;
    }
    const isEmpty = (v) => v == null || v.trim().length === 0;

    const columns = React.useMemo(() => [
        {
            field: 'category',
            headerName: '点検区分',
            flex: 0.7,
            minWidth: 110,
            maxWidth: 110,
            sortComparator: (v1, v2, param1, param2) => {
                const diffStr = categoryOrder[v1] - categoryOrder[v2];
                const row1 = param1.api.getRow(param1.id);
                const row2 = param2.api.getRow(param2.id);
                return diffStr !== 0 ? diffStr : tieBreaker(row1, row2);
            }
        },
        {
            field: 'kojiCD',
            headerName: '工事コード',
            type: 'number',
            flex: 0.8,
            minWidth: 120,
            maxWidth: 120,
            align: 'left',
            headerAlign: 'left',
            renderCell: (params) => {
                let url;

                switch (params.row.category) {
                    case "3ヵ月点検":
                        url = `/LandingPage?tenken=true&reportstatus=${params.row.statusCD === 1 || params.row.statusCD === 0 ? false : true}&kojicode=${params.value.trimEnd()}&reporttype=0&term=3mt`;
                        break;
                    case "6ヵ月点検":
                        url = `/LandingPage?tenken=true&reportstatus=${params.row.statusCD === 1 || params.row.statusCD === 0 ? false : true}&kojicode=${params.value.trimEnd()}&reporttype=0&term=6mt`;
                        break;
                    case "12ヵ月点検":
                        url = `/LandingPage?tenken=true&reportstatus=${params.row.statusCD === 1 || params.row.statusCD === 0 ? false : true}&kojicode=${params.value.trimEnd()}&reporttype=0&term=12mt`;
                        break;
                    case "24ヵ月点検":
                        url = `/LandingPage?tenken=true&reportstatus=${params.row.statusCD === 1 || params.row.statusCD === 0 ? false : true}&kojicode=${params.value.trimEnd()}&reporttype=0&term=24mt`;
                        break;
                    case "4年点検":
                        url = `/LandingPage?tenken=true&reportstatus=${params.row.statusCD === 1 || params.row.statusCD === 0 ? false : true}&kojicode=${params.value.trimEnd()}&reporttype=1&term=4yt`;
                        break;
                    case "7年点検":
                        url = `/LandingPage?tenken=true&reportstatus=${params.row.statusCD === 1 || params.row.statusCD === 0 ? false : true}&kojicode=${params.value.trimEnd()}&reporttype=1&term=7yt`;
                        break
                    case "10年点検":
                        url = `/LandingPage?tenken=true&reportstatus=${params.row.statusCD === 1 || params.row.statusCD === 0 ? false : true}&kojicode=${params.value.trimEnd()}&reporttype=1&term=10yt`;
                        break
                    default:
                        url = `/LandingPage?tenken=false&kojicode=${params.value.trimEnd()}`;
                        break
                }

                if (params.row.status === "OMS") {
                    return (
                        params.value.trimEnd()
                    )
                } else {
                    return (
                        <a href={url} target="_blank" rel="noopener noreferrer">
                            {params.value}
                        </a>
                    );
                }
            },
            sortComparator: (v1, v2, param1, param2) => {
                const row1 = param1.api.getRow(param1.id);
                const row2 = param2.api.getRow(param2.id);
                if (isEmpty(v1) && isEmpty(v2)) return tieBreaker(row1, row2);
                if (isEmpty(v1)) return 1;
                if (isEmpty(v2)) return -1;
                const diffStr = v1.localeCompare(v2, 'ja', { numeric: true });
                return diffStr !== 0 ? diffStr : tieBreaker(row1, row2);
            }
        },
        {
            field: 'status',
            headerName: '状態',
            flex: 0.5,
            minWidth: 140,
            maxWidth: 140,
            renderCell: (params) => {
                switch (params.row.statusCD) {
                    case 2:
                        return (<span style={{ color: "#d32f2f" }}>{params.row.status}</span>);
                    default:
                        return (<span >{params.row.status}</span>);
                }
            },
            sortComparator: (v1, v2, param1, param2) => {
                const order = { "未作成": 0, "作成中": 1, "作成済み": 2, "作成済み(確定)": 3, "OMS": 4 };
                const diffStr = order[v1] - order[v2];
                const row1 = param1.api.getRow(param1.id);
                const row2 = param2.api.getRow(param2.id);
                const diffCD = row1.statusCD - row2.statusCD;
                return diffStr !== 0 ? diffStr : diffCD !== 0 ? diffCD : tieBreaker(row1, row2);
            }
        },
        //{
        //    field: 'fixChecked',
        //    headerName: '確定',
        //    flex: 0.5,
        //    minWidth: 70,
        //    maxWidth: 70,
        //    renderCell: (params) => {
        //        const rand = Math.floor(Math.random() * (10 - 1 + 1)) + 1;
        //        return (
        //            <Checkbox
        //                disabled
        //                checked={rand % 2 === 0
        //                }
        //            />
        //        );
        //    }
        //},
        {
            field: 'yashikiName',
            headerName: '邸名',
            flex: 1,
            minWidth: 295,
            maxWidth: 295,
            renderCell: (params) => {
                return (
                    <Typography sx={{
                        ml: 0.5,
                        mb: 0.5,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                    }}>{params.row.yashikiName}</Typography>
                )
            },
            sortComparator: (v1, v2, param1, param2) => {
                const row1 = param1.api.getRow(param1.id);
                const row2 = param2.api.getRow(param2.id);
                if (isEmpty(v1) && isEmpty(v2)) return tieBreaker(row1, row2);
                if (isEmpty(v1)) return 1;
                if (isEmpty(v2)) return -1;
                const diffStr = v1.localeCompare(v2, 'ja', { numeric: true });
                return diffStr !== 0 ? diffStr : tieBreaker(row1, row2);
            }
        },
        {
            field: 'branch',
            headerName: '担当支店',
            flex: 1,
            minWidth: 120,
            maxWidth: 120,
            sortComparator: (v1, v2, param1, param2) => {
                const row1 = param1.api.getRow(param1.id);
                const row2 = param2.api.getRow(param2.id);
                if (isEmpty(v1) && isEmpty(v2)) return tieBreaker(row1, row2);
                if (isEmpty(v1)) return 1;
                if (isEmpty(v2)) return -1;
                const diffStr = v1.localeCompare(v2, 'ja', { numeric: true });
                return diffStr !== 0 ? diffStr : tieBreaker(row1, row2);
            }
        },
        {
            field: 'person',
            headerName: '担当者',
            flex: 2.4,
            minWidth: 210,
            maxWidth: 210,
            editable: true,
            type: 'singleSelect',
            valueOptions: personSelectList.length ? [
                ...personSelectList.map(item => ({
                    value: item.contractNo,
                    label: item.personName,
                })),
            ] : [],
            renderCell: (params) => {
                const isVisitDatePresent = params.row.visitdate;
                let value = params.value;
                if (!params.colDef.valueOptions.some(option => option.value === params.value)) {
                    const matchedOption = params.colDef.valueOptions.find(option => option.label === params.value);
                    value = matchedOption?.value || "";
                }

                const currentOption = params.colDef.valueOptions.find(option => option.value === value);
                const selectedPerson = currentOption?.label;

                return (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%',
                        cursor: isVisitDatePresent ? 'not-allowed' : 'pointer',
                        backgroundColor: !isVisitDatePresent ? '#f5f5f5' : null,
                        color: params.row.changedStatus ? 'ff3333' : '#010101',

                    }}>
                        <Typography sx={{
                            ml: 0.5,
                            mb: 0.5,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}>{selectedPerson}</Typography>
                        <EditIcon
                            style={{
                                marginLeft: 'auto',
                                fontSize: '1.2rem',
                                color: isVisitDatePresent ? 'gray' : '#289bdf',
                                cursor: isVisitDatePresent ? 'not-allowed' : 'pointer',
                            }}
                        />
                    </div>
                );
            },
            valueGetter: (params) => {
                const currentOption = params.colDef.valueOptions.find(
                    option => option.value === params.row.personCD
                );
                return currentOption?.value || '';
            },
            sortComparator: (v1, v2, param1, param2) => {
                const row1 = param1.api.getRow(param1.id);
                const row2 = param2.api.getRow(param2.id);
                const getRank = (row, v) => {
                    const hasVisit = !isEmpty(row.visitdate);
                    const hasV = !isEmpty(v);
                    //実績日なし&担当者なし
                    if (!hasVisit && !hasV) return 0;
                    //実績日なし&担当者あり
                    if (!hasVisit && hasV) return 1;
                    //実績日あり&担当者あり
                    if (hasVisit && hasV) return 2;
                    //実績日あり&担当者なし
                    if (hasVisit && !hasV) return 3;
                    return 99;
                };
                const rank1 = getRank(row1, v1);
                const rank2 = getRank(row2, v2);
                if (rank1 !== rank2) return rank1 - rank2;
                //同ランク比較
                if (!isEmpty(row1.Scheduleddate) || !isEmpty(row2.Scheduleddate)) {
                    //予定日比較
                    if (isEmpty(row1.Scheduleddate)) return -1;
                    if (isEmpty(row2.Scheduleddate)) return 1;
                    const t1 = new Date(row1.Scheduleddate).getTime();
                    const t2 = new Date(row2.Scheduleddate).getTime();
                    const diffDate = t2 - t1;
                    if (diffDate !== 0) return diffDate;
                }
                //担当者比較
                if (!isEmpty(v1) && !isEmpty(v2)) {
                    const diffStr = v1.localeCompare(v2, 'ja', { numeric: true });
                    if (diffStr !== 0) return diffStr;
                }
                //実績日比較
                if (!isEmpty(row1.visitdate) && !isEmpty(row2.visitdate)) {
                    const tv1 = new Date(row1.visitdate).getTime();
                    const tv2 = new Date(row2.visitdate).getTime();
                    const diffVisitDate = tv2 - tv1;
                    if (diffVisitDate !== 0) return diffVisitDate;
                }
                return tieBreaker(row1, row2);
            }
        },
        //{
        //    field: 'actions',
        //    type: 'actions',
        //    headerName: '',
        //    width: 50,
        //    cellClassName: 'actions',
        //    getActions: ({ id }) => {
        //        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        //        if (isInEditMode) {
        //            return [
        //                <GridActionsCellItem
        //                    icon={<EditIcon />}
        //                    label="Save"
        //                    sx={{
        //                        color: 'primary.main',
        //                    }}
        //                //onClick={handleSaveClick(id)}
        //                />
        //            ];
        //        } else {
        //            return [
        //                <GridActionsCellItem
        //                    icon={<EditIcon />}
        //                    label="Edit"
        //                    className="textPrimary"
        //                    //onClick={handleEditClick(id)}
        //                    color="inherit"
        //                />
        //            ];
        //        }
        //    },
        //},
        {
            field: 'Scheduleddate',
            headerName: '訪問予定日',
            flex: 0.5,
            minWidth: 116,
            maxWidth: 116,
            type: 'date',
            sortComparator: (v1, v2, param1, param2) => {
                const row1 = param1.api.getRow(param1.id);
                const row2 = param2.api.getRow(param2.id);
                if (isEmpty(v1) && isEmpty(v2)) return tieBreaker(row1, row2);
                if (isEmpty(v1)) return 1;
                if (isEmpty(v2)) return -1;
                const t1 = new Date(v1).getTime();
                const t2 = new Date(v2).getTime();
                const diffDate = t1 - t2;
                return diffDate !== 0 ? diffDate : tieBreaker(row1, row2);
            }
        },
        {
            field: 'visitdate',
            headerName: '訪問実績日 ',
            flex: 0.5,
            minWidth: 116,
            maxWidth: 116,
            type: 'date',
            sortComparator: (v1, v2, param1, param2) => {
                const row1 = param1.api.getRow(param1.id);
                const row2 = param2.api.getRow(param2.id);
                if (isEmpty(v1) && isEmpty(v2)) return tieBreaker(row1, row2);
                if (isEmpty(v1)) return 1;
                if (isEmpty(v2)) return -1;
                const t1 = new Date(v1).getTime();
                const t2 = new Date(v2).getTime();
                const diffDate = t1 - t2;
                return diffDate !== 0 ? diffDate : tieBreaker(row1, row2);
            }
        },
        {
            field: 'workingtime',
            headerName: '所要時間',
            flex: 0.5,
            minWidth: 100,
            maxWidth: 100,
            sortable: false,
        },
        {
            field: 'location',
            headerName: '位置情報',
            flex: 1.2,
            minWidth: 100,
            maxWidth: 100,
            renderCell: (params) => (
                params.value === "なし" ? (
                    <span>{params.value}</span>
                ) : (
                    <a href={`https://www.google.com/maps/search/?api=1&query=${params.value}`} target="_blank" rel="noopener noreferrer">
                        あり
                    </a>
                )
            ),
            sortComparator: (v1, v2, param1, param2) => {
                const isEmpty = (v) => v === "なし";
                const row1 = param1.api.getRow(param1.id);
                const row2 = param2.api.getRow(param2.id);
                const e1 = isEmpty(v1);
                const e2 = isEmpty(v2);
                if (e1 !== e2) {
                    return e1 ? 1 : -1;
                }
                return tieBreaker(row1, row2);
            }
        }
    ], [rowModesModel, personSelectList, list]);

    const { control, getValues, setValue, handleSubmit } = useForm({
        defaultValues: {
            kojiCD: "",
            tantoName: "",
            tantoShiten: "",
            customerNameKana: "",
        },
        mode: "onBlur",
        reValidateMode: "onBlur",
    });
    const validationRules = {
        kojiCD: {
            maxLength: {
                value: 15,
            },
            pattern: {
                value: /^[0-9a-zA-Z]+$/,
                message: "半角英数字のみ入力可能です",
            },
        },
        tantoName: {
            maxLength: {
                value: 15,
            }
        },
        customerNameKana: {
            pattern: {
                value: /^[\uFF65-\uFF9F\sA-Za-z0-9]*$/,
                message: "半角英数カナで入力してください",
            },
        }
    }
    //検索条件リセット
    const propertyAssignmentResetClick = () => {
        if (JSON.stringify(baseList) !== JSON.stringify(list)) {
            setUnconfirmedDeleteCheck(true);
            setUnconfirmedCmd("reset");
        } else {
            propertyAssignmentReset();
        }
    }
    const propertyAssignmentReset = () => {
        setProcessing_searchReset(true);
        setValue("kojiCD", "", { shouldValidate: true });
        setValue("tantoName", "", { shouldValidate: true });
        setValue("tantoShiten", "", { shouldValidate: true });
        setValue("customerNameKana", "", { shouldValidate: true });
        setList([]);
        setBaseList([]);
        setSortModel([{ field: '', sort: 'asc' }])
        setPaginationModel({ page: 0, pageSize: 100 })
        sessionStorage.removeItem('contractSearchCondition');
        setProcessing_searchReset(false);
    }

    //アカウント管理画面
    const onClickToAccountManagement = () => {
        if (JSON.stringify(baseList) !== JSON.stringify(list)) {
            setUnconfirmedDeleteCheck(true);
            setUnconfirmedCmd("moveToAccountManagement");
        } else {
            toAccountManagement()
        }
    }
    const toAccountManagement = () => {
        navigate("/inspection/accountManagement/list");
    }

    //戻るボタン
    const onClickToBack = () => {
        if (JSON.stringify(baseList) !== JSON.stringify(list)) {
            setUnconfirmedDeleteCheck(true);
            setUnconfirmedCmd("moveToBack");
        } else {
            moveToBack()
        }
    }
    const moveToBack = () => {
        navigate("/inspection");
    }

    //変更チェック
    const UnconfirmedCancelClick = () => {
        setUnconfirmedDeleteCheck(false);
    }
    const UnconfirmedExeClick = () => {
        if (unconfirmedCmd === "search") {
            propertyAssignmentSearch();
        } else if (unconfirmedCmd === "reset") {
            propertyAssignmentReset()
        } else if (unconfirmedCmd === "moveToAccountManagement") {
            toAccountManagement()
        } else if (unconfirmedCmd === "moveToBack") {
            moveToBack();
        }
        setUnconfirmedDeleteCheck(false);
    }


    //請負担当者割り当て登録処理
    const onClickPropertyAssignment = () => {

        if (JSON.stringify(baseList) === JSON.stringify(list)) {
            alert("変更されたデータがありません。")
            return;
        } else if (JSON.stringify(baseList) !== JSON.stringify(list)) {
            const changes = list
                .filter((item) => {
                    const baseItem = baseList.find((base) => base.id === item.id);
                    return JSON.stringify(baseItem) !== JSON.stringify(item);
                })
                .map((item) => {
                    return {
                        tenkenKbn: item.category,
                        kojiCD: item.kojiCD,
                        tantoCD: item.person,
                        visitAchievement: ""
                    };
                });

            setAssignList(changes);
            setPropertyAssignment(true)
            return;
        }
    }
    React.useEffect(() => {
        if (!propertyAssignment) { return }

        setProcessing(true)
        authAxios
            .post('api/inspection/InspectionVendor/asignContract', { VendorAsignPostInfoList: assignList }, { headers })
            .then(response => {
                if (response.status === 200) {
                    propertyAssignmentSearch()
                    setProcessing(false);
                }
            }).catch((response) => {
                alert("請負担当者割り当て登録処理に失敗しました。", response.body);
                switch (localStorage.getItem("loginType")) {
                    case "0":
                        navigate("/");
                        break
                    case "1":
                        navigate("/omsuser");
                        break
                    case "2":
                        navigate("/vender");
                        break
                    default:
                        navigate("/");
                }
                setProcessing(false)
            });
        setPropertyAssignment(false)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [propertyAssignment]);

    const mergeText = {
        ...jaJP.components.MuiDataGrid.defaultProps.localeText,
    }

    return (
        <InspectionContents style={{ marginLeft: 0, marginRight: 0 }} maxWidth="xl">
            <InspectionCommonDialog open={dialogState?.open} dialogState={dialogState} setDialogState={setDialogState} />
            <Grid container
                sx={{
                    display: 'flex',
                    alignItems: "flex-start",
                    //justifyContent: 'center'
                }}
            >
                <LoadingDialog load={processing} />
                <UnconfirmedDeleteCheckDialog
                    open={unconfirmedDeleteCheck}
                    cancelClick={() => UnconfirmedCancelClick()}
                    exeClick={() => UnconfirmedExeClick()}
                />
                <InspectionBreadcrumbs />
                <Grid container
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    spacing={1}
                >
                    <Grid container
                        sx={{
                            width: "100%"
                        }}
                    >
                        <Grid item xs={12} >
                            <Typography sx={{ fontSize: '1.7rem', px: "1vw" }}>いずれかの条件を指定して検索ボタンを押してください。</Typography>
                        </Grid>
                        <form onSubmit={handleSubmit(onSubmit, onError)} style={{ width: '100%' }}>
                            <Grid container item xs={12} sx={{ px: "1vw", pt: 1 }}>
                                <Grid container item rowSpacing={2} xs={7} sx={{ px: "1vw", pt: 1 }}>
                                    <Grid container item xs={12} >
                                        <Grid item xs="auto">
                                            <SearchIcon />
                                            <Controller
                                                control={control}
                                                name="tantoName"
                                                rules={validationRules.tantoName}
                                                render={({ field, fieldState }) =>
                                                    <TextField
                                                        {...field}
                                                        variant="standard"
                                                        label="担当者名"
                                                        error={fieldState.invalid}
                                                        helperText={fieldState.error?.message}
                                                        inputProps={{ maxLength: 15 }}
                                                        sx={{ width: 120 }}
                                                    />
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs="auto">
                                            <SearchIcon />
                                            <Controller
                                                control={control}
                                                name="kojiCD"
                                                rules={validationRules.kojiCD}
                                                render={({ field, fieldState }) =>
                                                    <TextField
                                                        {...field}
                                                        variant="standard"
                                                        label="工事コード"
                                                        error={fieldState.invalid}
                                                        helperText={fieldState.error?.message}
                                                        inputProps={{ maxLength: 15 }}
                                                        sx={{
                                                            width: 80,
                                                            "& .MuiFormHelperText-root": {
                                                                fontSize: "16px"
                                                            }
                                                        }}
                                                    />
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs="auto">
                                            <SearchIcon />
                                            <Controller
                                                control={control}
                                                name="tantoShiten"
                                                render={({ field, fieldState }) => (
                                                    <FormControl error={fieldState.invalid} >
                                                        <InputLabel id="area-label">支店</InputLabel>
                                                        <Select
                                                            labelId="shiten-label"
                                                            label="支店"
                                                            variant="standard"
                                                            sx={{ width: 120 }}
                                                            {...field}
                                                        >
                                                            {shitenSelectList.map((row, index) => {
                                                                return (
                                                                    <MenuItem key={index} value={row.shitenCD}>{row.shitenName}</MenuItem>
                                                                );
                                                            })}
                                                        </Select>
                                                        <FormHelperText>{fieldState.error?.message}</FormHelperText>
                                                    </FormControl>
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12} >
                                        <SearchIcon />
                                        <Grid item xs>
                                            <Controller
                                                control={control}
                                                name="customerNameKana"
                                                rules={validationRules.customerNameKana}
                                                render={({ field, fieldState }) => (
                                                    <TextField
                                                        {...field}
                                                        id="customerNameKana"
                                                        label="邸名（半角カナ）"
                                                        variant="standard"
                                                        fullWidth
                                                        error={fieldState.invalid}
                                                        helperText={fieldState.error?.message}
                                                        inputProps={{ maxLength: 40 }}
                                                        sx={{
                                                            "& .MuiFormHelperText-root": {
                                                                fontSize: "16px"
                                                            }
                                                        }}
                                                        onBlur={(e) => {
                                                            let converted = toHalfWidthKana(e.target.value);
                                                            converted = toHalfWidthAlpha(converted);
                                                            converted = toHalfWidthNumber(converted);
                                                            if (converted !== e.target.value) {
                                                                field.onChange(converted);
                                                            }
                                                            field.onBlur();
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                let converted = toHalfWidthKana(e.target.value);
                                                                converted = toHalfWidthAlpha(converted);
                                                                converted = toHalfWidthNumber(converted);

                                                                if (converted !== e.target.value) {
                                                                    field.onChange(converted);
                                                                }
                                                            }
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid container item xs={5} spacing={2} display="flex" justifyContent="center" alignItems="center">
                                    <Grid item xs={6} sx={{ width: '100%' }} >
                                        <NomalButton
                                            fullWidth
                                            className="confButton"
                                            type="submit"
                                            variant="contained"
                                            value="search"
                                            sx={{ fontSize: '1.2rem', px: 3, py: 1 }}
                                            disabled={processing_search}
                                        ><SearchIcon sx={{ mr: 1 }} />
                                            {processing_search ? "検索中" : "検索"}
                                        </NomalButton>
                                        <LoadingDialog load={processing_search} />
                                    </Grid>
                                    <Grid item xs={6} sx={{ width: '100%' }} >
                                        <CautionButton
                                            fullWidth
                                            type="button"
                                            sx={{ fontSize: '1.2rem', px: 3, py: 1 }}
                                            disabled={processing_searchReset}
                                            onClick={() => propertyAssignmentResetClick()}
                                        ><RefreshIcon sx={{ mr: 1 }} />
                                            {processing_searchReset ? "リセット中" : "検索条件リセット"}
                                        </CautionButton>
                                        <LoadingDialog load={processing_searchReset} />
                                    </Grid>
                                    <Grid item xs={12} sx={{ width: '100%' }} >
                                        <NomalButton
                                            fullWidth
                                            type="button"
                                            sx={{ fontSize: '1.2rem', px: 3, py: 1 }}
                                            disabled={processing_searchReset}
                                            onClick={() => onClickPropertyAssignment()}
                                        ><EditIcon sx={{ mr: 1 }} />
                                            割当て情報登録
                                        </NomalButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Grid>
                    <Grid
                        item
                        sx={{
                            height: '73vh',
                            width: "100%",
                            display: 'flex',
                            maxHeight: "70vh",
                            flexDirection: 'column',
                            [`.${gridClasses.cell}.edit`]: {
                                backgroundColor: '#ff943975',
                                color: '#606060',
                            },
                            [`.${gridClasses.cell}.editChange`]: {
                                backgroundColor: '#ff943975',
                                color: '#ff3333',
                            },
                        }}
                    >
                        <DataGrid
                            rows={list}
                            columns={columns}
                            editMode="row"
                            rowModesModel={rowModesModel}
                            onRowModesModelChange={handleRowModesModelChange}
                            processRowUpdate={processRowUpdate}
                            disableColumnMenu

                            hideFooterSelectedRowCount
                            localeText={mergeText}
                            //onCellFocusOut={handleCellFocusOut}
                            experimentalFeatures={{ newEditingApi: true }}
                            autoGenerateColumns={false}
                            components={{
                                NoRowsOverlay: () => (
                                    <div style={{ textAlign: "center", padding: "1rem" }} />
                                ),
                                Pagination: (props) => <CustomPagination {...props} rows={list} paginationModel={paginationModel} setPaginationModel={setPaginationModel} />,
                            }}
                            isCellEditable={(params) => {
                                if (params.field === 'person') {
                                    return !params.row.visitdate;
                                }
                            }}
                            getCellClassName={(params) => {
                                if (params.field === "person") {
                                    let classNames = !params.row.visitdate ? "edit" : null;
                                    classNames = classNames === "edit" ? params.row.changedStatus ? "editChange" : "edit" : null;
                                    return classNames;
                                }
                                return "";
                            }}
                            sx={{
                                '& .MuiDataGrid-cell': {
                                    fontSize: '1.1rem',
                                },
                                '& .MuiDataGrid-columnHeaders': {
                                    fontSize: '1.2rem',
                                    backgroundColor: '#289bdf',
                                    color: '#ffffff',
                                }
                            }}
                            sortingOrder={['asc', 'desc']}
                            onSortModelChange={(model) => {
                                setSortModel(model);
                                if (model.length > 0) {
                                    const { field, sort } = model[0];
                                    setPaginationModel({ page: 0, pageSize: 100 })
                                    const previousCondition = sessionStorage.getItem('contractSearchCondition');
                                    if (previousCondition) {
                                        const searchConditions = JSON.parse(previousCondition);
                                        const newCondition = {
                                            ...searchConditions,
                                            sort: {
                                                order: sort,
                                                orderBy: field,
                                            },
                                            pagination:
                                            {
                                                page: 0
                                            }
                                        }
                                        sessionStorage.setItem('contractSearchCondition', JSON.stringify(newCondition));
                                    }
                                }
                            }}
                            sortModel={sortModel}
                            pagination
                            page={paginationModel.page}
                            pageSize={paginationModel.pageSize}
                            onPageChange={(newPage) =>
                                setPaginationModel((prev) => ({ ...prev, page: newPage }))
                            }
                        />
                    </Grid >
                    <Grid container
                        sx={{
                            width: "100%",
                        }}
                    >
                        <Grid item sx={{ mx: 2, my: 2 }} >
                            <GrayButton sx={{ fontSize: '1.2rem', px: 4, py: 1, mx: 2 }} onClick={() => onClickToBack()}>
                                <UndoIcon sx={{ mr: 1 }} />
                                戻る
                            </GrayButton>
                            <NomalButton sx={{ fontSize: '1.2rem', px: 4, py: 1, mx: 2 }} onClick={() => onClickToAccountManagement()}>
                                <AssignmentIndIcon sx={{ mr: 1 }} />
                                アカウント管理画面
                            </NomalButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
        </InspectionContents>
    );
}